import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TYPE_MENU } from 'app/core/models/constans.model';
import { DbService } from 'app/core/services/db.service';
import * as moment from 'moment';
import { COLLECTIONS_BD } from '../../../core/models/collections.model';
import { Item, Menu } from '../../models/menu.model';
import { Restaurant } from '../../models/restaurants.model';
import { MenuStorageService } from '../../services/menu-storage.service';
import { MenuService } from '../../services/menu.service';
import { SectionMenu } from './../../models/menu.model';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  /**
   * Informacion del restaurante actual
   */
  restaurant: Restaurant = {} as Restaurant;
  /**
   * Items seleccionados para visualizarse en el home
   */
  items: Item[] = [];
  /**
   * Seccion de modelo para poder enviar items a
   * componente items image
   */
  section: SectionMenu = {} as SectionMenu;
  /**
   * Informacion del menu seleccionado
   */
  menu: Menu = {} as Menu;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  /**
   * Fecha actual
   */
  date = moment(new Date()).format('YYYY-MM-DD');
  constructor(
    private menuService: MenuService,
    private db: DbService,
    private menuStorage: MenuStorageService,
    private router: Router,
    private activateRoute: ActivatedRoute,
  ) {
    this.getRestaurant();
    setTimeout(() => {
      this.validateItems();
    }, 500);
  }

  ngOnInit(): void {
    if (this.activateRoute.snapshot.params.lang) {
      this.menuService.setLang(this.activateRoute.snapshot.params.lang.toUpperCase());
    }
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }

  /**
   * Intercambia los valores del lenguaje seleccionado
   */
  selectLanguage(): void {
    if (this.language === 'ES') {
      this.language = 'EN';
      this.menuService.setLang('EN');
    } else {
      this.menuService.setLang('ES');
      this.language = 'ES';
    }
  }



  /**
   * Cierra el componente home
   */
  close(): void {
    this.menuService.setHome(false);
    if (this.restaurant.menuType === TYPE_MENU.oneMenu) {
      this.router.navigateByUrl(`menu-detail/${this.activateRoute.snapshot.params.id}/menu`);
    }
  }

  /**
   * Indica si se debe ver o no el boton
   * de ver menu
   *
   * @returns boolean
   */
  viewButtonMenu(): boolean {
    return true;
  }
  /**
   * Navega al menu en pdf
   *
   * @param type tipo de menu pdf imagesMenuEn o imagesMenuEs
   */
  goMenuPDF(type: string): void {
    this.router.navigateByUrl(`menu-detail/${this.activateRoute.snapshot.params.id}/${type}`);
  }

  /**
   * Valida los items a mostrar en pantalla
   */
  private validateItems(): void {
    this.db.get(`${COLLECTIONS_BD.restaurants}/${this.activateRoute.snapshot.params.id}/menu`)
      .subscribe((menus: Menu[]) => {
        const exist = menus.find((m: Menu) => m.departament === 'cocina');
        if (exist) {
          this.menu = exist;
        } else {
          this.menu = menus[0];
        }
        this.items = [];
        menus.forEach((menu: Menu) => {
          this.items = this.items.concat(this.getHomeItems(menu.sections));
          this.section.items = this.items;
        });
      });
  }

  /**
   * Busca en secciones los elementos con el atributo home true
   *
   * @param sections secciones a buscar items con home activado
   * @returns items a mostrar en home
   */
  private getHomeItems(sections: SectionMenu[]): Item[] {
    return sections.reduce((acum: Item[], current: SectionMenu) => {
      acum.push(...current.items.filter((i: Item) => (i.home && i.available === 'S')));
      return acum;
    }, []);
  }

  /**
   * Obtiene la info del restaurante actual
   */
  private getRestaurant(): void {
    this.menuStorage.getRestaurant().subscribe((r: Restaurant) => {
      this.restaurant = r;
      if (r.language) {
        this.menuService.setLang(r.language);
        this.language = r.language;
      } else {
        this.menuService.setLang('ES');
      }
    });
  }

}
